import type { AxiosError } from 'axios';
import axios from 'axios';
import Router from 'next/router';

import { logger } from 'Services/logger/logger';
import { DEALER_BLOCKED_STATUSES } from 'Utilities/consts';
import { ACCESS_RESTRICTED_BLOCKED_DEALER } from 'Utilities/fetch.helpers';
import ROUTES, { API_ROUTES } from 'Utilities/routes';

import type { GetInitialPropsMiddleware } from '../getInitialPropsMiddlewares.types';

type CheckPermissionsData = {
	code: string;
};

export const blockPendingCheck: GetInitialPropsMiddleware = async (context, next) => {
	const { nextContext } = context;

	const { isSSR } = nextContext;

	if (!isSSR) {
		let dealerIsBlocked = false;

		await axios.get(API_ROUTES.CHECK_PERMISSIONS).catch(async (err) => {
			const { code = '' } = ((err as AxiosError)?.response?.data as CheckPermissionsData) || {};
			if (code === ACCESS_RESTRICTED_BLOCKED_DEALER) {
				dealerIsBlocked = true;
			}
		});

		if (dealerIsBlocked) {
			logger.warn({
				context: { path: window.location.pathname },
				message: 'Blocked dealer redirected from restricted page',
				scope: 'blockPendingCheck:client',
			});
			await Router.push(ROUTES.INDEX.href);
			return;
		}
	} else if (DEALER_BLOCKED_STATUSES.has(nextContext.req?.user?.dealerStatus.slug ?? '')) {
		const { trackBlockedAccess: track } = await import('Services/datadogServer/trackBlockedAccess');
		track({
			dealerContactId: nextContext.req?.user?.id,
			dealerId: nextContext.req?.user?.dealerId,
			dealerStatus: nextContext.req?.user?.dealerStatus.slug,
			method: nextContext.req?.method ?? '',
			path: nextContext.req?.url ?? '',
			reason: 'dealer_blocked',
			scope: 'blockPendingCheck',
		});

		nextContext.res?.redirect(302, '/');

		return;
	}

	await next();
};
